/* eslint-disable no-console */

export const logLevels = ['trace', 'debug', 'info', 'warn', 'error'] as const;
type LogLevel = (typeof logLevels)[number];

const DEFAULT_LOG_LEVEL = 'error';

export type Logger = {
    error: (...args: unknown[]) => void;
    warn: (...args: unknown[]) => void;
    info: (...args: unknown[]) => void;
    debug: (...args: unknown[]) => void;
    trace: (...args: unknown[]) => void;
};

const shouldLog = (level: LogLevel) => {
    return (
        logLevels.indexOf(level) >=
        logLevels.indexOf(
            (process.env.REACT_APP_LOG_LEVEL || DEFAULT_LOG_LEVEL) as LogLevel
        )
    );
};

const logger = {
    error: (...args: unknown[]) => shouldLog('error') && console.error(...args),
    warn: (...args: unknown[]) => shouldLog('warn') && console.warn(...args),
    info: (...args: unknown[]) => shouldLog('info') && console.info(...args),
    debug: (...args: unknown[]) => shouldLog('debug') && console.debug(...args),
    trace: (...args: unknown[]) => shouldLog('trace') && console.trace(...args),
};

export default logger;
